import { CustomEvent } from '@piwikpro/react-piwik-pro'
import { LucideIcon } from 'lucide-react'
import React from 'react'

import { TrackedButtonProps } from '../../types/TrackedButton'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

const TrackedButton = ({
  icon,
  label,
  tooltip,
  severity: _severity,
  outlined,
  size,
  children,
  variant,
  loading,
  hidden,
  ...props
}: TrackedButtonProps & {
  icon?: LucideIcon
  label?: string
  tooltip?: string
  severity?: string
  outlined?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  size?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  variant?: any
  loading?: boolean | null
  hidden?: boolean
}) => {
  if (hidden) {
    return null
  }

  const finalVariant = outlined ? 'outline' : variant
  const mappedSize =
    size === 'small' ? 'sm' : size === 'large' ? 'lg' : size === 'full' ? 'full' : size

  // Check if button has only an icon (no label or children)
  const hasOnlyIcon = icon && !label && !children

  const iconElement = icon
    ? React.createElement(icon, {
        className: cn(size === 'full' ? 'h-5 w-5' : 'h-4 w-4', hasOnlyIcon && 'mx-auto'),
      })
    : undefined

  const button = (
    <Button
      {...props}
      variant={finalVariant}
      size={mappedSize}
      loading={loading ?? undefined}
      icon={iconElement}
      className={cn(
        props.className,
        size === 'full' && 'h-10 w-10 rounded-full p-0',
        hasOnlyIcon && 'aspect-square'
      )}
      onClick={(e) => {
        CustomEvent.trackEvent(props.trackingkey, 'on_click')
        if (props.onClick) {
          props.onClick(e)
        }
      }}
    >
      {size !== 'full' && (label || children)}
    </Button>
  )

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent color="secondary">
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    )
  }

  return button
}

export default TrackedButton
